<div class="modal-header">
    <h4 class="modal-title">{{ Title }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{ Message }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="decline()">Decline</button>
      <button type="button" class="btn btn-primary" (click)="accept()">Accept</button>
    </div>